module.exports = __webpack_public_path__ + "img/f20.beb617a3.png";